module.exports = __webpack_public_path__ + "static/media/29-12.d83218c8.mp3";